import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyArcHJfpcjsT5fRi__q_JFM15ZXal-09Ws",
  authDomain: "projectsell-594d7.firebaseapp.com",
  databaseURL: "https://projectsell-594d7.firebaseio.com",
  projectId: "projectsell-594d7",
  storageBucket: "projectsell-594d7.appspot.com",
  messagingSenderId: "640263485671",
  appId: "1:640263485671:web:027c02f2774ae6db51ca42",
  measurementId: "G-G5PH8N4KDH",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

export { db, auth, storage };
